<template>
  <div>
    <section aria-labelledby="history-title">
      <Card>
        <div class="divide-y divide-gray-200">
          <CardHeader>
            <CardTitle id="notes-title"> History </CardTitle>
          </CardHeader>
          <CardContent class="px-4 py-6 sm:px-6">
            <SimpleRecordList
              :columns="['updated by', 'field changed', 'from', 'to', 'updated at']"
              :records="job.history"
            />
          </CardContent>
        </div>
      </Card>
    </section>
  </div>
</template>

<script>
import SimpleRecordList from '../shared/SimpleRecordList.vue';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default {
  components: {
    SimpleRecordList,
    Card,
    CardContent,
    CardHeader,
    CardTitle,
  },
  props: ['job'],
};
</script>
